import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class RegionListDataService extends DataService<typeof Model.General.Logic.ViewModels.RegionSummary, Model.General.Logic.ViewModels.RegionSummary, RegionSummary> {
    protected map(entity: Model.General.Logic.ViewModels.RegionSummary): RegionSummary {
        return new RegionSummaryModel(entity);
    }

    public static make(context?: any): RegionListDataService {
        return new RegionListDataService(context, ctx=>ctx.RegionsSummaries);
    }
}

export class RegionSummaryModel extends EntityModel<Model.General.Logic.ViewModels.RegionSummary, RegionSummary> implements RegionSummary {

    @property<RegionSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<RegionSummaryModel>(o => o.entity.code, (o, value) => o.entity.code = value)
    public code: string;

	@property<RegionSummaryModel>(o => o.entity.codeIso2, (o, value) => o.entity.codeIso2 = value)
	public codeIso2: string;
	
    @property<RegionSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
    public displayName: string;

    @property<RegionSummaryModel>(o => o.entity.parentRegionId, (o, value) => o.entity.parentRegionId = value)
    public parentRegionId?: number;

    @property<RegionSummaryModel>(o => o.entity.hasChildren, (o, value) => o.entity.hasChildren = value)
    public hasChildren: boolean;
}



// WEBPACK FOOTER //
// ./src/app/general/regions/list/region-list.data.ts